module.exports = __webpack_public_path__ + "img/sock-icon.1764fc01.svg";